// axios
import axios from 'axios'
import rutasjson from "@/assets/utils/rutas.json"


axios.defaults.baseURL = rutasjson.axios

export default axios
